<template>
    <div >
        <!-- 照明用电 -->
        <EquipmentElectricity :lightSortArr="lightSortArr"/>
        <EquipmentControl />
        <EnergyStatistics :energyData="energyData" v-if="energyData.length > 0"/>
        <HumidityStatistics  v-if="flag"/>
        <SystemModel />
        <!-- 照明设备启停 -->
        <!-- <Statistics /> -->
    </div>
</template>

<script>
    const EquipmentElectricity = () => import("./components/EquipmentElectricity.vue")
    const EquipmentControl = () => import("./components/EquipmentControl.vue")
    const EnergyStatistics = () => import("./components/EnergyStatistics.vue")
    const SystemModel = () => import("./components/SystemModel.vue")
    const HumidityStatistics = () => import("./components/HumidityStatistics.vue")
    const Statistics = () => import("./components/Statistics")

    import { getTodayYesTime, lastMonth } from '../../../utils//common/index'

    export default {
        name: "havc",
        props:{
            selectBuildId:String,
            arrLight:{
                type:Array,
                default:[],
            }
        },
        components: {
            EquipmentElectricity,
            EquipmentControl,
            EnergyStatistics,
            HumidityStatistics,
            SystemModel,
            Statistics
        },
        data() {
            return {
                lightSortArr:[],  // 设备用电数据
                energyData:[], //能耗统计图表数据
                arr:[],  //能耗统计图表数据备用
                flag:true
            };
        },
        mounted(){
            this.sortingArr()
            this.getEnergyConsumption()
        },
        methods: {
           // 处理数组 
            sortingArr(){
                let items = ['#5B8FF9','#F6BD16','#FF9D4D'];
                if(this.arrLight.length >0){
                    
                    let arr = this.arrLight.map((item, index)=>{
                        let max = item[0].itemPower
                        return item.map((val, key)=>{
                            let width = Math.floor(val.itemPower / max * 100) 
                            // let color = '#'+('00000'+ (Math.random()*0x1000000<<0).toString(16)).substr(-6); 
                            let color = items[Math.floor(Math.random()*items.length)];
                            return {
                                title:val.title,
                                id:val.id,
                                ratioStyle:{
                                    width:`${width}%` ,
                                    background: color
                                },
                                val:val.itemPower
                            }
                        })
                    })
                    this.lightSortArr = arr
                }
            },
            // 获取暖通能耗图表
            async getEnergyConsumption(){ 
                let _this = this
                let time = getTodayYesTime()
                let lastMon = lastMonth()
                
                let dataDay = {
                    projectId:this.$store.state.projectId,
                    date:`${time.today}T00:00:00Z`,
                    itemType:'LIGHTING',
                    range:'DAY'
                }
                let dataYes = {
                    projectId:this.$store.state.projectId,
                    date:`${time.yesterday}T00:00:00Z`,
                    itemType:'LIGHTING',
                    range:'DAY'
                }
                let dataMon = {
                    projectId:this.$store.state.projectId,
                    date:`${time.today}T00:00:00Z`,
                    itemType:'LIGHTING',
                    range:'MONTH'
                }
                let dataLastMon = {
                    projectId:this.$store.state.projectId,
                    date:`${lastMon}T00:00:00Z`,
                    itemType:'LIGHTING',
                    range:'MONTH'
                }
                let res = await Promise.all([
                    _this.$http.getEnergyConsumptionProject(dataDay), 
                    _this.$http.getEnergyConsumptionProject(dataMon),
                    _this.$http.getEnergyConsumptionProject(dataYes), 
                    _this.$http.getEnergyConsumptionProject(dataLastMon),
                    ])
                console.log(res);
                    
                let arr = res.map((item, index)=>{
                    return  item.data.data.result.map((val, key)=>{
                        return Number(val).toFixed(2)
                    })
                })

                this.energyData = [
                    [arr[0], arr[2]],
                    [arr[1], arr[3]],
                ]
                this.arr = [
                    [arr[0], arr[2]],
                    [arr[1], arr[3]],
                ]
            }
        },
        activated(){
            this.energyData = this.arr
            this.flag = true
        },
        deactivated(){
            console.log('失活');
            this.energyData = []
            this.flag = false
        }
    };
</script>

<style lang="less" scoped>

    .menuButtons{
        width: 10vw;
        height: 7vh;
        position: fixed;
        top: 6.8vh;
        left: 22.5vw;
        display: flex;
        flex-direction: row;
    }

    .posAlarm{
        width: 20.8vw;
        position: fixed;
        top: 8vh;
        border-radius: 4px;
        right: 22vw;
        background: linear-gradient(0deg, rgba(0, 33, 59, 0.8) 0%, rgba(3, 13, 24, 0.8) 100%);
        box-shadow: 
            0 0 16rem 0 #FF5555, 
            0 0 16rem 0 #FF5555;
        padding: 0 5rem;
        .alarmEvents{
            width: 100%;
            padding: 0 15rem;
            max-height: 92vh;
            overflow-x:hidden ;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                width: 4px;
            }
            &::-webkit-scrollbar-thumb{
                background-color: rgba(255, 255, 255, 0.7);
                border-radius: 2rem;
            }
            .alarmEvent{
                height: 7.87vh;
                width: 95%;
                .atop{
                    padding-top: 1.4vh;
                    font-size: 24rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #FFFFFF;
                    position: relative;
                    .img{
                        width: 2.6vh;
                        height: 2.6vh;
                        vertical-align: middle;
                        margin-top: 0.4vh;
                        display: inline-block;
                        background: url('../../../assets/img/r.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .eventName{
                        display: inline-block;
                        text-shadow: 
                        0 0 1vh  #de5962,
                        0 0 2vh  #de5962,
                        0 0 3vh  #de5962;
                    }
                    span{
                        position: absolute;
                        right: 0;
                        top: 2vh;
                        font-size: 14rem;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.7);
                    }
                    img:nth-of-type(1){
                        width: 16rem;
                        height: 16rem;
                        position: absolute;
                        top: 2.1vh;
                        right: -2.7vh;
                    }
                }
                .abottom{
                    font-size: 16rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.7);
                    padding-left: 1.3vw;
                    padding-top: 0.2vh;
                    position: relative;
                    .con{
                        width: 14vw; 
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    img{
                        width: 0.7vw;
                        height: 1.7vh;
                        position: absolute;
                        right: 0;
                        top: 0;
                    }
                }
                
            }
            
        }
    }
    .yellowAlarm{
        box-shadow: 
            0 0 16rem 0 #F5AA00, 
            0 0 16rem 0 #F5AA00;  
            .alarmEvents{
                .alarmEvent{
                    .atop{
                        .img{
                            background: url('../../../assets/img/y.png') no-repeat;
                        }
                        .eventName{  
                            text-shadow: 
                                0 0 1vh  #F5AA00,
                                0 0 2vh  #F5AA00,
                                0 0 3vh  #F5AA00;
                        }
                    }
                }
            }
            
    }
    .blueAlarm{
        box-shadow: 
            0 0 16rem 0 #0D94FF, 
            0 0 16rem 0 #0D94FF;
            .alarmEvents{
                .alarmEvent{
                    .atop{
                        .img{
                            background: url('../../../assets/img/b.png') no-repeat;
                        }
                        .eventName{  
                            text-shadow: 
                                0 0 1vh  #0D94FF,
                                0 0 2vh  #0D94FF,
                                0 0 3vh  #0D94FF;
                        }
                    }
                }
            }
    }

    .alarm-enter,
    .alarm-leave-to {
        top: 0,
    }

    .alarm-enter-active,
    .alarm-leave-active {
        transition: top 1s
    }

    .posAlarms{
        width: 20.8vw;
        position: fixed;
        top: 8vh;
        border-radius: 4px;
        right: 22vw;
        background: linear-gradient(0deg, rgba(0, 33, 59, 0.85) 0%, rgba(3, 13, 24, 0.9) 100%);
        padding: 0 5rem;
        .alarmEventss{
            width: 100%;
            padding: 0 15rem;
            max-height: 92vh;
            overflow-x:hidden ;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                width: 4px;
            }
            &::-webkit-scrollbar-thumb{
                background-color: rgba(255, 255, 255, 0.7);
                border-radius: 2rem;
            }
            .alarmEvents{
                height: 7.87vh;
                width: 100%;
                border-bottom: 1px solid rgba(255, 255, 255, 0.3);
                .atops{
                    padding-top: 1.4vh;
                    font-size: 24rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #FFFFFF;
                    position: relative;
                    img{
                        width: 2.6vh;
                        height: 2.6vh;
                        vertical-align: middle;
                    }
                    span{
                        position: absolute;
                        right: 0;
                        top: 2vh;
                        font-size: 14rem;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.7);
                    }
                }
                .abottoms{
                    font-size: 16rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.7);
                    padding-left: 1.7vw;
                    padding-top: 0.2vh;
                    position: relative;
                    .cons{
                        width: 14vw; 
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    img{
                        width: 0.7vw;
                        height: 1.7vh;
                        position: absolute;
                        right: 0;
                        top: 0;
                    }
                }
            }

            .noneEvent{
                height: 3vh;
                line-height: 3vh;
                font-size: 16rem;
                text-align: center;
                color: #FFFFFF;
            }
        }
    }
</style>